import { Injectable } from '@angular/core';
import { tap, catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { BoToastrService } from '../../shared';
import { API } from '../config/api';
import { SUCCESS } from '../../../@shared/constants';
import { ErrorResponse } from '../config/common';
import { CreatePalletRateRequest } from './pallet-rate.DTO';
import { environment } from '../../../environments/environment';

@Injectable()
export class PalletRateService {
    public baseUrl = environment.baseUrl;
    constructor(
        private _http: HttpClient,
        private _toastr: BoToastrService
    ) { }
    
    public getPalletRates(model: CreatePalletRateRequest) {
        return this._http.post(`${API.PALLET_RATE.GET_PALLET_RATE}`, model);
    }

    public update(model: any) {
        return this._http.put(`${API.PALLET_RATE.UPDATE}`, model)
            .pipe(
                tap(() => {
                    this._toastr.successCode(SUCCESS.UPDATE_PALLET_RATE);
                }),
                catchError((err: ErrorResponse) => {
                    this._toastr.errors(err.error.errors);
                    throw err;
                })
            );
    }
    
    
}
